import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { labels } from "../../constants/recipeListing.constants"
import SearchInput from "../../components/UI/SearchInput/SearchInput"
import * as styles from "./SearchJobs-tw-styles"
import { updatePageUrl } from "../../helpers/search"
import { useDispatch, useSelector } from "react-redux"
import { searchJobGtm } from "../../constants/gtm.constants"
import { updateSearchTerm } from "../../redux/actions/jobListActions"

const SearchJobs = props => {
  const { jobListReducer } = useSelector(state => state)
  const search = props?.searchTerm
  const {
    setSearchTerm,
    setCurrentPage,
    filtersData,
    filterValidation,
    updateFilterValidation,
  } = props
  const [term, setTerm] = useState(search || "")
  const dispatch = useDispatch()
  const style = styles[props?.variant] || styles["SEARCH_RECIPES"]

  // set search input field value
  useEffect(() => {
    setTerm(search)
  }, [search])

  const onChange = e => {
    setTerm(e?.target?.value)
  }

  const onSubmit = () => {
    if (typeof window !== "undefined") {
      //data layer push
      if (window?.dataLayer) {
        searchJobGtm.GAeventLabel = term
        searchJobGtm.GAeventCategory = "searchJob"
        window.dataLayer.push({ ...searchJobGtm })
      }
    }
    updatePageUrl({
      ...jobListReducer,
      filtersData: filtersData,
      search: term?.replace(/\//g, ""),
    })
    setSearchTerm(term)
    setCurrentPage(1)
    dispatch(updateSearchTerm(term))
  }
  return (
    <div className={style?.container}>
      <div className={style?.serachWrpr}>
        <SearchInput
          placeholder={labels?.searchPlaceHolder}
          onSearchSubmit={onSubmit}
          style={style?.searchboxStyles}
          searchTerm={term}
          onChange={onChange}
          filterValidation={filterValidation}
          updateFilterValidation={updateFilterValidation}
        />
      </div>
    </div>
  )
}
SearchJobs.propTypes = {
  searchTerm: PropTypes.string,
  variant: PropTypes.string,
  setSearchTerm: PropTypes.func,
  setCurrentPage: PropTypes.func,
  filtersData: PropTypes.object,
  filterValidation: PropTypes.bool,
  updateFilterValidation: PropTypes.func,
}

export default SearchJobs
